import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import Loading from "./../components/LoadingError/Loading";
import { login } from "./../redux/Actions/UserActions";

const Login = ({ location, history }) => {
  window.scrollTo(0, 0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const redirect = location.search ? location.search.split("=")[1] : "/";

  const userLogin = useSelector((state) => state.userLogin);
  const { error, loading, userInfo } = userLogin;

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
  }, [userInfo, history, redirect]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };
  return (
    <>

      <div className="w-full flex justify-center items-center">
        <div className="w-[--page-width] p-16 flex flex-col justify-center items-center gap-4">
          {error && <Message variant="alert-danger">{error}</Message>}
          {loading && <Loading />}
          <h4 className="text-center font-bold text-2xl">Đăng nhập</h4>
          <form
            className="flex justify-center items-center flex-col w-72 gap-4"
            onSubmit={submitHandler}
          >
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border rounded-xl text-sm p-2 w-full"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
               className="border rounded-xl text-sm p-2  w-full"
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className=" bg-[--color-button-3] text-white hover:bg-[--color-button-2] hover:text-black px-4 py-2 rounded-full">Đăng nhập</button>
            <Link
                to={redirect ? `/register?redirect=${redirect}` : "/register"}
                 className="hover:text-[--color-button-3] text-sm"
              >
               Bạn chưa cóa tài khoản? Tạo tài khoản ngay.
              </Link>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
